import { Component, Input, inject } from '@angular/core'
import { ManageFieldsComponent } from '@app/feature/manage-fields/manage-fields.component'
import { TbDividerComponent } from '@components-library/tb-divider/tb-divider.component'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { TbMenuListComponent } from '@components-library/tb-menu-list/tb-menu-list.component'
import { TbMenuListItemComponent } from '@components-library/tb-menu-list-item/tb-menu-list-item.component'
import { ModalFlowManagerService } from '@components-library/tb-modal-manager/modal-flow-manager.service'
import { MainBusinessRecord } from '@models/ui'
import { TranslocoModule } from '@jsverse/transloco'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { RecordsService } from '@services/records.service'
import { UiFacadeService } from '@services/store-facade/ui-facade.service'
import { take } from 'rxjs/operators'
import { ModalContainerTypes } from '@components-library/tb-modal-manager/modal-manager.service'
import { RecordCardNavigationService } from '@app/pages/service/record-card-navigation.service'

@UntilDestroy()
@Component({
    selector: 'app-board-card-menu',
    imports: [
        TbDividerComponent,
        TbIconComponent,
        TbMenuListComponent,
        TbMenuListItemComponent,
        TranslocoModule,
    ],
    templateUrl: './board-card-menu.component.html',
})
export class BoardCardMenuComponent {
    private readonly recordService = inject(RecordsService)
    private readonly modalFlowManagerService = inject(ModalFlowManagerService)
    private readonly uiFacadeService = inject(UiFacadeService)
    private readonly recordCardNavigationService = inject(RecordCardNavigationService)

    @Input({ required: true }) record!: MainBusinessRecord
    @Input() containerLayout!: ModalContainerTypes

    delete() {
        this.uiFacadeService
            .wrapRequestWithViewLoader(this.recordService.deleteRecord(this.record))
            .pipe(take(1), untilDestroyed(this))
            .subscribe()
    }

    duplicate() {
        this.recordService.duplicateRecord(this.record)
    }

    manageFields() {
        this.modalFlowManagerService.openDialog({ component: ManageFieldsComponent })
    }

    openCard() {
        this.recordCardNavigationService.openRecordCard({
            recordGuid: this.record.guid,
            isWorkspace: true,
        })
    }
}
